import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Refetch on window focus - this is what the user requested
      refetchOnWindowFocus: true,
      // Refetch when the network comes back online
      refetchOnReconnect: true,
      // Keep data fresh for sync operations
      staleTime: 1000 * 60 * 2, // 2 minutes
      // Cache data for a reasonable time
      gcTime: 1000 * 60 * 10, // 10 minutes (renamed from cacheTime)
      // Retry failed requests
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors except for authentication
        if (error instanceof Error) {
          const status = (error as any)?.status
          if (status >= 400 && status < 500 && status !== 401) {
            return false
          }
        }
        return failureCount < 3
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Retry mutations on network errors
      retry: 1,
    },
  },
})
